<div *ngIf="(vm$ | async) as vm">

    <!--- login -->
    <div *ngIf="vm.loginFormVm as fvm">
        <mdb-card narrower="true" cascade="true">
            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <app-card-header [headingSize]="2" [title]="fvm.title">
                    </app-card-header>
                </div>
                <div class="col-sm-6 col-lg-8 text-center text-sm-left">
                    <a *ngFor="let a of fvm.actions" class="pl-2 action-link" (click)="loginActionClicked(vm, a.code)">{{a.name}}
                    </a>
                </div>
            </div>
            <mdb-card-body cascade="true">
                
                <div class="row">
                    <div class="col-md-6">
                        <app-form-input [vm]="fvm.email" (textChanged)="loginTextChanged(vm)"></app-form-input>
                    </div>
                    <div class="col-md-6">
                        <app-form-input [vm]="fvm.password" (textChanged)="loginTextChanged(vm)"></app-form-input>
                    </div>
                </div>
    
                <!-- ok / cancel -->
                <div class="row">
                    <div class="col-md-12 text-center">
                        <app-form-ok-cancel [vm]="fvm.okCancelVm" (okClicked)="loginClicked(vm)"></app-form-ok-cancel>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>

    <!-- register -->
    <div *ngIf="vm.registerFormVm as fvm">
        <mdb-card narrower="true" cascade="true">
            <div class="row">
                <div class="col-md-8">
                    <app-card-header [headingSize]="2" [title]="fvm.title">
                    </app-card-header>
                </div>
            </div>
            <mdb-card-body cascade="true">
                
                <div class="row">
                    <div class="col-md-6">
                        <app-form-input [vm]="fvm.displayName" (textChanged)="registerTextChanged(vm)"></app-form-input>
                    </div>
                    <div class="col-md-6">
                        <app-form-input [vm]="fvm.email" (textChanged)="registerTextChanged(vm)"></app-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <app-form-input [vm]="fvm.password" (textChanged)="registerTextChanged(vm)"></app-form-input>
                    </div>
                    <div class="col-md-6">
                        <app-form-input [vm]="fvm.password2" (textChanged)="registerTextChanged(vm)"></app-form-input>
                    </div>
                </div>

                <!-- ok / cancel -->
                <div class="row">
                    <div class="col-md-12 text-center">
                        <app-form-ok-cancel [vm]="fvm.okCancelVm" (okClicked)="registerClicked(vm)" (cancelClicked)="cancelClicked(vm)"></app-form-ok-cancel>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>        
    </div>

    <!-- forgot password -->
    <div *ngIf="vm.forgotPasswordFormVm as fvm">
        <mdb-card narrower="true" cascade="true">
            <div class="row">
                <div class="col-md-8">
                    <app-card-header [headingSize]="2" [title]="fvm.title">
                    </app-card-header>
                </div>
            </div>
            <mdb-card-body cascade="true">
                
                <div class="row">
                    <div class="col-md-12">
                        <app-form-input [vm]="fvm.email" (textChanged)="forgotPasswordTextChanged(vm)"></app-form-input>
                    </div>
                </div>

                <!-- ok / cancel -->
                <div class="row">
                    <div class="col-md-12 text-center">
                        <app-form-ok-cancel [vm]="fvm.okCancelVm" (okClicked)="forgotPasswordClicked(vm)" (cancelClicked)="cancelClicked(vm)"></app-form-ok-cancel>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>        
    </div>    
</div>